import script from "./TwConfirmationCode.vue?vue&type=script&setup=true&lang=ts"
export * from "./TwConfirmationCode.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__